import { Component, Input } from '@angular/core';
import { User } from '../../model/user';
import { MenuService } from '../../_client-service/menu/menu.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

    @Input() user: User;

    constructor(
        private menuSrv: MenuService
    ) { }

    toggleMenu() {
        this.menuSrv.setMenuStatus('');
    }

}
